import { Fragment } from "react";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import Divider from "@vapor/react-material/Divider";
import Modal from "@vapor/react-material/Modal";
import Stack from "@vapor/react-material/Stack";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { modalStyle } from "../businessLogic/styles";

export const CrossSellingModal = ({ show, onClose }) => {
    const handleScopriDiPiu = () => {
        window.open("", "_blank");
    };

    return (
        <Fragment>
            <Modal
                key="cross-selling-modal"
                aria-labelledby="cross-selling-modal-title"
                aria-describedby="cross-selling-modal-description"
                open={show}
                onClose={onClose}
            >
                <Box sx={modalStyle}>
                    <Stack direction="column" spacing={0} justifyContent="left" alignItems="left">
                        <ExtendedTypography
                            variant="titleSmall"
                            color="primary.main"
                            sx={{ p: 2, pl: 3 }}
                        >
                            Firma digitale
                        </ExtendedTypography>
                        <Divider orientation="horizontal" flexItem />
                        <ExtendedTypography variant="body" sx={{ p: 2, pl: 3, pt: 3, pb: 3 }}>
                            Per poter firmare i documenti, occorre avere il servizio Signature attivo e per te non risulta esserlo, 
                            clicca sul pulsante sottostante per sapere come fare per attivarlo
                        </ExtendedTypography>
                    </Stack>
                    <Stack
                        direction="row"
                        spacing={1}
                        sx={{ p: 1, bgcolor: "#F2F5F8" }}
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        <Button variant="outlined" size="small" onClick={onClose}>
                            Chiudi
                        </Button>
                        <Button variant="contained" size="small" onClick={handleScopriDiPiu}>
                            Scopri di più
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </Fragment>
    );
};
